import { Injectable } from '@angular/core';
import { AppSettings, apiCredentials } from '../storan-constant';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignupuserService {
  userDetails: any;
  dynamicTextSubject = new BehaviorSubject<any>({});
  headersUserApi = new HttpHeaders();
  headersSnapApi = new HttpHeaders();
  dynamicText$:Observable<any> = this.dynamicTextSubject.asObservable();
  loginvalidationmessage: any='';
  growerDetails: any;
  constructor(private http: HttpClient) { }

  setUserDetails(userDetails: any) {
    this.userDetails = userDetails;
  }
  getUserDetails() {
    return this.userDetails;
  }
  
  updateDynamicText(isLoggedIn:any){
    this.dynamicTextSubject.next(isLoggedIn);
  }
  public addHeadersUserApi() {
    this.headersUserApi = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('APIKeyUserAPI')
    })
  }
  public addHeadersSnapApi() {
    this.headersSnapApi = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('APIKeySNAPAPI')
    })
    // console.log(this.headersSnapApi.get('Authorization'));
  }
loadScript(scriptUrl:any):Promise<void>{{
  return  new Promise((resolve,reject)=>{
    const existingscript = document.getElementById(scriptUrl);
    if(existingscript){
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.type='text/javascript';
    script.id='dynamicScript';
    script.async = true;
    script.onload =() =>
    resolve();
    script.onerror =(error:any) =>reject('script load error:'+ error);
    document.body.appendChild(script);
  })
}

}
  postLoginToken(): Observable<any> {
    return this.http.post<any>(AppSettings.postLoginToken, apiCredentials)
  }
  storenregister(signupObj:any){
    let appURL: string = AppSettings.storenregister;
    this.addHeadersUserApi();
    return this.http.post<any>(appURL, signupObj, { headers: this.headersUserApi }).pipe((data) => data, catchError(this.handleError));
  }
  forgotPassword(forgotParams: any) {
    let appUrl: string = AppSettings.forgotPassword;
    this.addHeadersUserApi();
    return this.http.post<any>(appUrl, forgotParams, {
      headers: this.headersUserApi,
    }).pipe((data) => data, catchError(this.handleError));
  }
  changePassword(passwordParam: any) {
    let appUrl: string = AppSettings.changePassword;
    this.addHeadersUserApi();
    return this.http.post<any>(appUrl, passwordParam, {
      headers: this.headersUserApi,
    }).pipe((data) => data, catchError(this.handleError));
  }
  UpdateGrowersLastLogin(email: string) {
    this.addHeadersSnapApi();
    const emailObj = { email: email };
    let appUrl: string = AppSettings.updateGrowersLastLogin;
    return this.http.post<any>(appUrl, JSON.stringify(emailObj) ,{
      headers: this.headersSnapApi
    }).pipe((data) => data, catchError(this.handleError));
  }
  UpdateGrowersLoginAttempt(email: any) {
    let appUrl: string = AppSettings.updateGrowersLoginAttempt;
    this.addHeadersSnapApi();
    const emailObj = { email: email };
    return this.http.post<any>(appUrl, JSON.stringify(emailObj),{
      headers: this.headersSnapApi
    }).pipe((data) => data, catchError(this.handleError));
  }

  validatephone(phonenum:any){
    let appURL: string = AppSettings.validatephone + '/' + phonenum;
    this.addHeadersUserApi();
   return this.http.get<any>(appURL, {
     headers: this.headersUserApi
   }).pipe((data) => data, catchError(this.handleError));
  }

  validateEmailExist(email:any){
    let appUrl: string = AppSettings.emailUsers+'email='+email+'&website=ssp';
    this.addHeadersUserApi();
    return this.http.get<any>(appUrl, {
      headers: this.headersUserApi,
    }).pipe((data) => data, catchError(this.handleError));
  }
  activeUser(activationCode:any){
    let appURL: string = AppSettings.activeUser + '&activationCode='+activationCode+'&website=ssp';
    this.addHeadersUserApi();
   return this.http.get<any>(appURL, {
     headers: this.headersUserApi
   }).pipe((data) => data, catchError(this.handleError));
  }
  storenvalidatetoken(storanobj:any){
  let appUrl: string = AppSettings.storenvalidatetoken;
    this.addHeadersUserApi();
    return this.http.post<any>(appUrl, storanobj, {
      headers: this.headersUserApi,
    }).pipe((data) => data, catchError(this.handleError));
  }
  validatemail(email:any){
    let appURL: string = AppSettings.validatemail + '/' + email;
    this.addHeadersUserApi();
   return this.http.get<any>(appURL, {
     headers: this.headersUserApi
   }).pipe((data) => data, catchError(this.handleError));
  }
  public handleError(err: HttpErrorResponse) {
    let errMsg: any;
    if (err instanceof Error) {
      errMsg = err.message;
    } else {
      errMsg = err.status;
    }
    return throwError(errMsg);
  }
}
